import React, { useState, useEffect } from 'react';
import { Button, Input, Select, Radio, Typography } from 'antd';
import {
  getFilterFromJira,
  getServiceDeskProject,
  getIssues,
} from '../../../skills/skills_action';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
const { Option } = Select;
const { Text } = Typography;
const ApphomeFilter = (props) => {
  const dispatch = useDispatch();
  const {
    findType,
    setFindType,
    apphome,
    preBuiltFilter,
    setPreBuiltFilter,
    customFilters,
    jqlFilter,
    setJqlFilter,
    selectedFilterFromJira,
    setSelectedFilterFromJira,
    requestTypeFilter,
    setRequestTypeFilter,
    requestTypeProjectInfo,
    setRequestTypeProjectInfo,
    errors,
  } = props;
  const jsdProjects = useSelector((state) => state.skills.jsd_projects);
  const requestTypes = useSelector((state) => state.skills.requestTypes);
  const [showCustomFilterModal, setCustomFilterModal] = useState(false);
  const pageInfo =
    apphome &&
    apphome.pages &&
    apphome.pages.find((page) => page._id === (apphome && apphome.pageView));
  const pageViewType = pageInfo && pageInfo.pageViewType;
  const [filtersFromJira, setFiltersFromJira] = useState([]);
  const skills = useSelector((state) => state.skills.skills);
  const jiraSkill = skills && skills.find((skill) => skill.key === 'jira');
  const servertype =
    jiraSkill &&
    jiraSkill.skill_metadata &&
    jiraSkill.skill_metadata.metadata &&
    jiraSkill.skill_metadata.metadata.server_type;
  const handleJql = (e) => {
    setJqlFilter(e.target.value);
  };

  useEffect(() => {
    (async () => {
      if (findType === 'filterfromjira') {
        const res = await getFilterFromJira(props.match.params.wId);
        if (res && res.data && res.data.items) {
          setFiltersFromJira(res.data.items);
        }
      } else if (
        findType === 'prebuiltfilter' &&
        preBuiltFilter == 'tickets_by_req_type'
      ) {
        dispatch(
          getServiceDeskProject(
            props.match.params.wId,
            props.match.params.skill_id,
            {
              saveInJSDProjects: true,
              user_id: localStorage.getItem('trooprUserId'),
            }
          )
        );
      }
    })();
  }, [findType, preBuiltFilter]);

  const onChangeProject = async (event, data) => {
    setRequestTypeProjectInfo({ project: data.project });
    await dispatch(
      getIssues(props.match.params.wId, data.project.id, true, true)
    );
  };
  const handleRequestType = (event, data) => {
    setRequestTypeProjectInfo({
      ...requestTypeProjectInfo,
      requestType: data.requestType,
    });
  };

  return (
    <div>
      <Radio.Group
        onChange={(e) => setFindType(e.target.value)}
        value={findType}
      >
        <Radio value='prebuiltfilter'>Pre-build filter</Radio>
        {/* <Radio value='customfilter'>Custom filter</Radio> */}
        {pageViewType === 'issues' && (
          <Radio value='jqlfilter'>JQL filter</Radio>
        )}
        {servertype === 'jira_cloud_oauth' && pageViewType === 'issues' && (
          <Radio value='filterfromjira'>Filter from Jira</Radio>
        )}
      </Radio.Group>
      <div style={{ marginTop: '20px' }}>
        {findType === 'prebuiltfilter' && (
          <div>
            {pageViewType === 'issues' && (
              <Select
                style={{ width: 246 }}
                value={preBuiltFilter}
                onChange={(value) => setPreBuiltFilter(value)}
              >
                <Option value='assigned_to_me'>Assigned to me</Option>
                <Option value='reported_by_me'>Reported by me</Option>
                <Option value='watched_by_me'>Watched by me</Option>
                <Option value='not_done_issues'>All Open</Option>
              </Select>
            )}
            {pageViewType === 'requests' && (
              <div style={{ display: 'flex', gap: '24px' }}>
                <div>
                  <Select
                    style={{ width: 246 }}
                    value={preBuiltFilter}
                    onChange={(value) => {
                      setPreBuiltFilter(value);
                      setRequestTypeFilter('');
                    }}
                  >
                    <Option value='tickets_by_status'>Request by status</Option>
                    <Option value='tickets_by_creator'>
                      Request by Creator
                    </Option>
                    <Option value='tickets_by_req_type'>
                      Requests by Request Type
                    </Option>
                  </Select>
                </div>
                <div>
                  {preBuiltFilter == 'tickets_by_status' && (
                    <Select
                      style={{ width: 246 }}
                      value={requestTypeFilter || 'OPEN_REQUESTS'}
                      onChange={(value) => {
                        setRequestTypeFilter(value);
                      }}
                    >
                      <Option value='ALL_REQUESTS'>Any status</Option>
                      <Option value='OPEN_REQUESTS'>Open status</Option>
                      <Option value='CLOSED_REQUESTS'>Closed status</Option>
                    </Select>
                  )}
                  {preBuiltFilter == 'tickets_by_creator' && (
                    <Select
                      style={{ width: 246 }}
                      value={requestTypeFilter || 'OWNED_REQUESTS'}
                      onChange={(value) => {
                        setRequestTypeFilter(value);
                      }}
                    >
                      <Option value='OWNED_REQUESTS'>Created by me</Option>
                      <Option value='ALL_REQUESTS'>Created by anyone</Option>
                      <Option value='PARTICIPATED_REQUESTS'>
                        Where i am participant
                      </Option>
                    </Select>
                  )}
                  {preBuiltFilter == 'tickets_by_req_type' && (
                    <>
                      <Select
                        style={{ width: 246, marginRight: 8 }}
                        placeholder='Select project'
                        value={
                          (requestTypeProjectInfo &&
                            requestTypeProjectInfo.project &&
                            requestTypeProjectInfo.project.projectId) ||
                          undefined
                        }
                        onChange={(value, data) => onChangeProject(value, data)}
                        showSearch={true}
                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }

                        // disabled={true}
                      >
                        {jsdProjects &&
                          jsdProjects.map((project, index) => {
                            return (
                              <Option
                                key={project.projectId}
                                value={project.projectId || project.id}
                                project={project}
                              >
                                {project.projectName +
                                  ` (${project.projectKey})`}
                              </Option>
                            );
                          })}
                      </Select>
                      <span>&nbsp;</span>
                      <Select
                        style={{ width: 246 }}
                        value={
                          (requestTypeProjectInfo &&
                            requestTypeProjectInfo.requestType &&
                            requestTypeProjectInfo.requestType.value) ||
                          undefined
                        }
                        onChange={(e, data) => handleRequestType(e, data)}
                        showSearch={true}
                        placeholder='Select Request type'
                      >
                        {/* {console.log("ISSUE TYPE",cDefault.defaultIssue)} */}
                        {requestTypes &&
                          requestTypes.map((issue, index) => (
                            <Option
                              requestType={issue}
                              key={issue.value}
                              value={issue.value}
                            >
                              {issue.text}
                            </Option>
                          ))}
                      </Select>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {findType === 'customfilter' && (
          <div>
            <>
              <Text style={{ marginRight: 8 }}>
                {customFilters &&
                Object.values(customFilters).filter(
                  (value) => value && value.length > 0
                ).length > 0
                  ? `${
                      Object.values(customFilters).filter(
                        (value) => value && value.length > 0
                      ).length
                    } field value(s) set`
                  : 'No field values set'}
              </Text>
              <a onClick={() => showCustomFilterModal(true)}>Update Filter</a>
            </>
          </div>
        )}
        {findType === 'jqlfilter' && (
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Input.TextArea
                style={{ width: 500 }}
                placeholder='write JQL query here'
                value={jqlFilter}
                onChange={(e) => {
                  handleJql(e);
                }}
              />
              {errors && errors.jqlFilter && (
                <Text
                  type='danger' /* style={{ marginLeft: "360px", marginTop: projectError ? "-22px" : "" }} */
                >
                  {errors.jqlFilter}
                </Text>
              )}
            </div>
          </div>
        )}
        {findType === 'filterfromjira' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Select
              style={{ width: 246 }}
              showSearch
              allowClear
              placeholder='Choose filter'
              value={selectedFilterFromJira ? selectedFilterFromJira : null}
              onChange={(value, data) => setSelectedFilterFromJira(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {filtersFromJira &&
                filtersFromJira.map((filter) => {
                  return (
                    <Option key={filter.id} value={filter.jql} data={filter}>
                      {filter.name}
                    </Option>
                  );
                })}
            </Select>
            {errors.selectedFilterFromJira && (
              <Text
                type='danger' /* style={{ marginLeft: "360px", marginTop: projectError ? "-22px" : "" }} */
              >
                {errors.selectedFilterFromJira}
              </Text>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(ApphomeFilter);
